import { reactive, ref } from 'vue';

import FormInputComponent from '@/components/_shared/_partials/form-input/form-input.vue';

export default {
  name: 'PurchaseCouponComponent',
  components: { FormInputComponent },
  props: {
    coupon: {
      type: String,
      required: false,
    },
  },
  setup(props) {
    const state = reactive({
      coupon: ref(null),
      update: async (data) => {
        const { key, value } = data;
        state[key] = value;
      },
    });

    if (props.coupon) state.update({ key: 'coupon', value: props.coupon })

    return { state };
  },
  methods: {
    validate: async function () {
      const { coupon } = this.state;
      this.$emit('validate', coupon);
    }
  }
};